import { publicEnv } from '~/features/environment/public';

/**
 * Returns the cookie domain based on the current environment.
 * Environments deployed to *.udacity.com subdomains use '.udacity.com'
 * so cookies are shared across subdomains. Local/test environments
 * return undefined so the browser uses the current hostname.
 */
export function getCookieDomain(): string | undefined {
  switch (publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME) {
    case 'production':
    case 'staging':
    case 'preview':
      return '.udacity.com';
    default:
      return undefined;
  }
}
